const SOLUTIONS = [
  {
    description: 'Descrição do produto #1',
    features: ['Feature 1', 'Feature 2', 'Feature 3'],
    img:
      'https://static.openfoodfacts.org/images/products/073/762/806/4502/ingredients_en.10.400.jpg',
    imgAlt: 'P1',
    link: '',
    name: 'Nome do Produto #1',
  },
  {
    description: 'Descrição do produto #2',
    features: ['Feature 1', 'Feature 2', 'Feature 3'],
    img:
      'https://static.openfoodfacts.org/images/products/073/762/806/4502/ingredients_en.10.400.jpg',
    imgAlt: 'P2',
    link: '',
    name: 'Nome do Produto #2',
  },
  {
    description: 'Descrição do produto #3',
    features: ['Feature 1', 'Feature 2', 'Feature 3'],
    img:
      'https://static.openfoodfacts.org/images/products/073/762/806/4502/ingredients_en.10.400.jpg',
    imgAlt: 'P3',
    link: '',
    name: 'Nome do Produto #3',
  },
  {
    description: 'Descrição do produto #4',
    features: ['Feature 1', 'Feature 2', 'Feature 3'],
    img:
      'https://static.openfoodfacts.org/images/products/073/762/806/4502/ingredients_en.10.400.jpg',
    imgAlt: 'P4',
    link: '',
    name: 'Nome do Produto #4',
  },
];

export default SOLUTIONS;
